import { X } from "lucide-react";
import Loading from "../shared/Loading";
import VerticalStepper from "./Stepper";

const LoanApplicationModal = ({
  children,
  closeBioInformation,
  activeIndex,
  handleNextStep,
  finishText = "Next",
  loading,
}) => {
  const steps = [
    { title: "Borrower’s personal information" },
    { title: "Borrower’s bio-data information" },
    { title: "Borrower’s next of kin" },
    { title: "Borrower’s income details" },
    { title: "Business Location" },
    { title: "Residence location" },
    { title: "Borrower’s Chattels" },
    { title: "Add Documents" },
    { title: "Add Guarantor(s)" },
    { title: "Send Documents & Finish" },
  ];

  const handleSaveAndClose = () => {
    closeBioInformation();
  };
  return (
    <div
      onClick={() => {
        closeBioInformation();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[1000px] overflow-y-auto h-[650px] bg-white rounded-[10px] relative"
      >
        <div
          onClick={closeBioInformation}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="absolute bottom-[10px] w-full px-[20px] left-0 flex items-center gap-[10px] justify-end">
          <button
            onClick={handleSaveAndClose}
            className="bg-[#F3F3F3] h-[35px] px-[20px] rounded-[30px] text-[#5C5C5C] font-medium text-[15px]"
          >
            Save & Close
          </button>
          <button
            disabled={loading}
            onClick={handleNextStep}
            className="h-[35px] bg-[#000000] rounded-[30px] flex items-center justify-center gap-[5px] px-[15px] text-[15px] font-bold text-white"
          >
            {loading && <Loading />}
            {finishText}
          </button>
        </div>
        <div className="flex h-full w-full">
          <div className="w-[27%] h-full px-[20px] py-[25px]">
            <VerticalStepper steps={steps} activeStep={activeIndex} />
          </div>
          <div className="w-[2px] bg-[#E7E7E7] h-full"></div>
          <div className="w-[70%] p-[20px] h-full">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default LoanApplicationModal;
